import { START_LOADING, DELETE_BRANCH, GET_BRANCHES, EDIT_BRANCH, CREATE_BRANCH, STOP_LOADING, BRANCH_ERROR } from "../branchesAction/types";


const INITIAL_STATE = {
  loading: false,
  success: false,
  message_valid: false
}

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case GET_BRANCHES:
      return {
        ...state,
        branches_list: action.payload,
        success: false,
        loading: false
      }
    case START_LOADING:
      return {
        ...state,
        loading: true
      }
    case CREATE_BRANCH:
      return {
        ...state,
        new_branch: action.payload,
        loading: false
      }
    case EDIT_BRANCH:
      return {
        ...state,
        edited_branch: action.payload,
        loading: false
      }
    case DELETE_BRANCH:
      return {
        ...state,
        success: true,
        loading: false
      }
    case STOP_LOADING:
      return {
        ...state,
        loading: false
      }
    case BRANCH_ERROR:
      return {
        ...state,
        error_message: action.payload,
        message_valid: !state.message_valid,
        loading: false
      }
    default:
      return {
        ...state
      }
  }
}